import React, { useEffect, useState } from "react";
import { View, Text, TextInput, FlatList, TouchableOpacity, StyleSheet } from "react-native";
import Feather from '@expo/vector-icons/Feather';

import { useIsFocused } from "@react-navigation/native";
import { useDispatch, useSelector } from "react-redux";
import getPlatformType from "../../helpers/helpers";
import { COLORS } from "../../screens/tenants/tenantOnboarding/screens/components/PropertyDetailsCard";
import EmptyState from "./EmptyState";
interface PropertyData {
  property?: {
    property_name?: string;
  };
  openflow_id?: string | number;
  open_flow_maintenance_issues?: any[];
  [key: string]: any;
}

interface PropertySearchProps {
  flos?: PropertyData[];
  flototal?: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  onSelectAll?: () => void;
  onSelectOne?: (row: PropertyData) => void;
  onView: (row: PropertyData) => void;
  refresh: () => void;
  onAdd: () => void;
}

function PropertySearch({
  flos = [],
  flototal = 0,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  onView,
  refresh,
  onAdd
}: PropertySearchProps) {
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [properties, setProperties] = useState([]);
  const focused = useIsFocused();
  const LoginState = useSelector((state) => state?.Login?.userDetails);
  const layout = getPlatformType();

  console.log("flos", flos)
  const [list, setList] = useState<PropertyData[]>([]);

  useEffect(() => {
    setList(flos || []);
  }, [flos]);

  return (
    <View style={styles.pageWrapper}>
      <View style={styles.headerCard}>
        <Text style={styles.headerTitle}>New Issue Submissions</Text>

        <Text style={styles.headerSubtitle}>
          Welcome to OpenBrix’s maintenance and issue reporting system.
          Your tenants can now submit their property maintenance issues
          directly to you, allowing you to resolve them efficiently.
        </Text>

        <View
          style={[
            styles.registerBox,
            layout !== "web" && styles.registerBoxMobile
          ]}
        >
          <View style={{ flex: 1 }}>
            <Text style={styles.registerTitle}>Register new issue</Text>

            <Text style={styles.registerDesc}>
              If your tenant notified you outside the system,
              click "Add Issue" and follow the process.
            </Text>
          </View>

          <TouchableOpacity
            style={[
              styles.addIssueButton,
              layout !== "web" && styles.addIssueButtonMobile
            ]}
            onPress={() => onAdd()}
          >
            <Feather name="plus-circle" size={18} color="#fff" />
            <Text style={styles.addIssueText}>ADD ISSUE</Text>
          </TouchableOpacity>
        </View>
      </View>

      {list && list?.length > 0 ?

        <View style={styles.tableCard}>
          {layout === "web" ? (
            <>
              <View style={styles.tableHeader}>
                <Text style={[styles.tableHeaderText, { flex: 2 }]}>PROPERTY</Text>
                <Text style={[styles.tableHeaderText, { flex: 1 }]}>LEAD TENANT</Text>
                <Text style={[styles.tableHeaderText, { width: 120 }]}>ISSUES</Text>
                <View style={{ width: 100 }} />
              </View>
            </>
          ) : null}
          <FlatList
            data={list}
            keyExtractor={(item) => item?.openflow_id}
            renderItem={({ item }) => {

              const propertyName = item?.displayAddress || "—";

              const leadTenantObj = item?.tenants?.find(
                (tenant: any) => tenant.is_lead
              );

              const leadTenantName =
                leadTenantObj?.app_user
                  ? `${leadTenantObj?.app_user?.user?.first_name || ""} ${leadTenantObj?.app_user?.user?.last_name || ""}`
                  : "—";

              const issuesCount = item?.open_flow_maintenance_issues?.length || 0;

              return layout === "web" ? (
                <View style={styles.tableRow}>
                  <Text style={[styles.cellText, { flex: 2 }]}>
                    {propertyName}
                  </Text>
                  <View style={{ flex: 1 }}>
                    <Text style={styles.cellText}>
                      {leadTenantName}
                    </Text>

                    <Text style={[styles.cellText, { color: "#6B7280", fontSize: 13 }]}>
                      {leadTenantObj?.app_user?.user?.email || "—"}
                    </Text>
                  </View>



                  <Text style={[styles.cellText, { width: 120 }]}>
                    {issuesCount}
                  </Text>

                  <TouchableOpacity
                    style={styles.viewButton}
                    onPress={() => onView(item)}
                  >
                    <Text style={styles.viewText}>VIEW</Text>
                  </TouchableOpacity>
                </View>
              ) :
                (
                  /* ---------------- MOBILE CARD ---------------- */
                  <View style={styles.mobileCard}>
                    <View style={styles.mobileRow}>
                      <Feather name="home" size={18} color="#8B5CF6" />
                      <Text style={styles.mobileTitle}>{propertyName}</Text>
                    </View>

                    <View style={styles.mobileRow}>
                      <Feather name="user" size={16} color="#6B7280" />
                      <View>
                        <Text style={styles.mobileText}>{leadTenantName}</Text>
                        <Text style={styles.emailText}>
                          {leadTenantObj?.app_user?.user?.email || "—"}
                        </Text>
                      </View>
                    </View>

                    <View style={styles.mobileBottom}>
                      <View style={styles.issueBadge}>
                        <Text style={styles.issueText}>
                          {issuesCount} Issues
                        </Text>
                      </View>

                      <TouchableOpacity
                        style={styles.viewButton}
                        onPress={() => onView(item)}
                      >
                        <Text style={styles.viewText}>VIEW</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                );
            }}

          />
        </View> : <EmptyState
          title="No Active Issues"
          subText="There are currently no active maintenance issues."
          buttonText="Add Issue"
          onButtonPress={() => onAdd()}
        />}

    </View>
  );

};
const layout = getPlatformType()
const styles = StyleSheet.create({

  registerBoxMobile: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 15,
  },

  addIssueButtonMobile: {
    width: "100%",
    justifyContent: "center",
    marginTop: 10,
  },

  headerTitle: {
    fontSize: layout === "web" ? 26 : 22,
    fontWeight: "700",
    color: "#7D57C1",
    marginBottom: 10,
  },
  emailText: {},
  headerSubtitle: {
    fontSize: layout === "web" ? 15 : 14,
    color: "#6B7280",
    lineHeight: 22,
    marginBottom: 25,
  },

  pageWrapper: {
    flex: 1,
  },
  headerCard: {
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 18,
    marginBottom: 30,
    shadowColor: "#000",
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 4 },
    elevation: 3,
  },



  registerBox: {
    backgroundColor: "#F9FAFB",
    borderRadius: 12,
    padding: 20,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  registerTitle: {
    fontSize: 18,
    fontWeight: "600",
    marginBottom: 5,
  },

  registerDesc: {
    fontSize: 14,
    color: "#6B7280",
  },

  addIssueButton: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: COLORS.primary,
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 30,
    gap: 8,
  },

  addIssueText: {
    color: "#fff",
    fontWeight: "600",
    letterSpacing: 1,
  },

  /* TABLE CARD */
  tableCard: {
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 20,
    shadowColor: "#000",
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 4 },
    elevation: 3,
  },

  tableHeader: {
    flexDirection: "row",
    paddingBottom: 15,
    borderBottomWidth: 1,
    borderColor: "#E5E7EB",
  },

  tableHeaderText: {
    fontSize: 13,
    fontWeight: "700",
    color: "#6B7280",
  },

  tableRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 18,
    borderBottomWidth: 1,
    borderColor: "#F1F1F1",
  },

  cellText: {
    fontSize: 15,
    color: "#374151",
  },

  viewButton: {
    backgroundColor: COLORS.primary,
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderRadius: 20,
    alignItems: "center",
    marginTop: 10,
    width: 130
  },

  viewText: {
    color: "#fff",
    fontWeight: "600",
  },
  mobileCard: {
    backgroundColor: "#F9FAFB",
    borderRadius: 14,
    padding: 16,
    marginBottom: 16,
  },

  mobileRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginBottom: 10,
  },

  mobileTitle: {
    fontSize: 16,
    fontWeight: "600",
    color: "#374151",
    flex: 1,
  },

  mobileText: {
    fontSize: 14,
    color: "#374151",
  },

  mobileBottom: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 10,
  },

  issueBadge: {
    backgroundColor: "#EDE9FE",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 20,
  },

  issueText: {
    color: COLORS.primary,
    fontWeight: "600",
    fontSize: 13,
  },
});


export default PropertySearch;